import React, { useState } from 'react'
import { Brain, ChevronDown, ChevronRight } from 'lucide-react'

interface ThinkingBlockProps {
  content: string
  isActive: boolean
  className?: string
}

export default function ThinkingBlock({ content, isActive, className = '' }: ThinkingBlockProps) {
  const [expanded, setExpanded] = useState(false)

  if (!content && !isActive) return null

  return (
    <div className={`mb-2 ${className}`}>
      <button
        type="button"
        onClick={() => setExpanded(prev => !prev)}
        className="flex w-full items-center gap-2 rounded-lg border border-amber-500/20 bg-amber-500/5 px-3 py-2 text-left text-xs text-amber-400/80 transition hover:bg-amber-500/10"
      >
        <Brain className={`h-3.5 w-3.5 flex-shrink-0 ${isActive ? 'animate-pulse' : ''}`} />
        <span className="flex-1 font-medium">
          {isActive ? 'Réflexion en cours…' : 'Réflexion terminée'}
        </span>
        {content && (
          expanded
            ? <ChevronDown className="h-3.5 w-3.5 flex-shrink-0" />
            : <ChevronRight className="h-3.5 w-3.5 flex-shrink-0" />
        )}
      </button>
      {expanded && content && (
        <div className="mt-1 max-h-40 overflow-y-auto rounded-lg border border-amber-500/10 bg-amber-500/5 px-3 py-2 text-xs leading-relaxed text-amber-300/60">
          {content}
        </div>
      )}
    </div>
  )
}
